import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import config from "../config.json";

export default class Quiz extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    campaigns: [],
    isEditMode: false,
    updatedQuiz: {
      quizName: "",
      question_en: "",
      question_da: "",
      answers: [], // {text: "Blue", correct: false}
      points: "",
      info_da: "",
      info_en: "",
    },
  };

  componentDidMount() {
    this.setState({ updatedQuiz: this.props.quiz });
    this.setState({ campaigns: this.props.campaigns });
  }

  handleQuizEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateQuiz(this.state.updatedQuiz);
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name.includes("answer")) {
      const split = name.split("answer");
      const answerIdx = split[1].split("_")[0];
      const lang = split[1].split("_")[1];

      const answers = [...this.state.updatedQuiz.answers];

      if (!name.includes("correct")) {
        answers[answerIdx][`text_${lang}`] = value;
      } else {
        answers[answerIdx].correct = value;
      }

      this.setState({
        updatedQuiz: {
          ...this.state.updatedQuiz,
          answers,
        },
      });
    } else {
      this.setState({
        updatedQuiz: {
          ...this.state.updatedQuiz,
          [name]: value,
        },
      });
    }
  };

  render() {
    return (
      <div className="tile box notification is-near-half m-small">
        <Fragment>
          <a
            href="/"
            onClick={this.handleQuizEdit}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteQuiz(this.props.quiz.id, event)
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <div>
            <p className="product-id">id: {this.props.quiz.id}</p>
            <p>Navn: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.quizName}
              onChange={this.handleInputChange}
              name={"quizName"}
            />
            <p>Spørgsmål dansk: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.question_da}
              onChange={this.handleInputChange}
              name={"question_da"}
            />
            <p>Spørgsmål engelsk: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.question_en}
              onChange={this.handleInputChange}
              name={"question_en"}
            />
            <p>Info dansk: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.info_da}
              onChange={this.handleInputChange}
              name={"info_da"}
            />
            <p>Info engelsk: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.info_en}
              onChange={this.handleInputChange}
              name={"info_en"}
            />

            <p>Point: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedQuiz.points}
              onChange={this.handleInputChange}
              name={"points"}
            />
            {this.state.updatedQuiz.answers.map((answer, idx) => (
              <>
                <div>
                  Svarmulighed {idx + 1} engelsk
                  <input
                    className="input is-medium"
                    type="text"
                    value={this.state.updatedQuiz.answers[idx].text_en}
                    onChange={this.handleInputChange}
                    name={"answer" + idx + "_en"}
                  />
                </div>

                <div>
                  Svarmulighed {idx + 1} dansk
                  <input
                    className="input is-medium"
                    type="text"
                    value={this.state.updatedQuiz.answers[idx].text_da}
                    onChange={this.handleInputChange}
                    name={"answer" + idx + "_da"}
                  />
                </div>

                <div>
                  <label
                    style={{ marginRight: "5px" }}
                    htmlFor={"answer" + idx + "_da_correct"}
                  >
                    Svarmulighed {idx + 1} korrekt
                  </label>
                  <input
                    className=" is-medium"
                    type="checkbox"
                    checked={this.state.updatedQuiz.answers[idx].correct}
                    onChange={this.handleInputChange}
                    name={"answer" + idx + "_da_correct"}
                    id={"answer" + idx + "_da_correct"}
                  />
                </div>
                <br />
              </>
            ))}

            <button
              type="submit"
              className="button is-info is-small"
              onClick={this.handleEditSave}
            >
              Gem
            </button>
          </div>
        ) : (
          <>
            <div className="column is-half">
              <p className="product-title">{this.props.quiz.quizName}</p>
              <p className="product-id">
                <b>Spørgsmål dansk:</b> {this.props.quiz.question_da}
              </p>

              <p className="product-id">
                <b>Spørgsmål engelsk:</b> {this.props.quiz.question_en}
              </p>

              <p className="product-id">
                <b>Info dansk:</b> {this.props.quiz.info_da}
              </p>

              <p className="product-id">
                <b>Info engelsk:</b> {this.props.quiz.info_en}
              </p>

              <p className="product-id">
                <b>Point:</b> {this.props.quiz.points}
              </p>

              <p className="product-id">
                <b>ID:</b> {this.props.quiz.id}
              </p>
            </div>
            <div className="column is-half">
              {this.props.quiz.answers.map((answer, idx) => {
                return (
                  <div
                    key={idx + this.props.quiz.id}
                    style={{
                      padding: 4,
                      marginBottom: 5,
                      border: "solid 1px black",
                      width: "fit-content",
                    }}
                  >
                    {" "}
                    <p className="product-id">
                      <b>Svarmulighed {idx + 1} dansk:</b> {answer.text_da}
                    </p>{" "}
                    <p key={idx + this.props.quiz.id} className="product-id">
                      <b>Svarmulighed {idx + 1} engelsk:</b> {answer.text_en}
                    </p>
                    {answer.correct ? "✅" : "⛔"}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  }
}
